module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "profile-header innerProfile",
    class: {
      'has-coverphoto': _vm.profile.cover_photo !== ''
    },
    style: ({
      'background-image': 'url(' + _vm.profile.cover_photo + ')'
    }),
    attrs: {
      "id": "profileHeader"
    }
  }, [_c('mu-card-text', {
    staticClass: "profile-header-content"
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "bottom",
      "justify": "bottom"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "bottom"
    }
  }, [_c('mu-row', {
    staticClass: "padRow",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "25",
      "tablet": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "profile-text desktop",
    attrs: {
      "width": "100",
      "desktop": "75",
      "tablet": "100",
      "align": "left"
    }
  }, [_c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.profile.display_name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "badges"
  }, [(_vm.profile.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.progress.percentage === 100 && !_vm.isHcpView) ? _c('user-badge', {
    attrs: {
      "type": "finished-program"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.champion) ? _c('user-badge', {
    attrs: {
      "type": "champion"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHcpView && _vm.isHcpVerified) ? _c('user-badge', {
    attrs: {
      "type": "hcp-verified"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showPrivacyInfo || _vm.profile.country !== null) ? _c('p', {
    staticClass: "country"
  }, [_c('country-badge', {
    attrs: {
      "alpha2": _vm.profile.location.alpha2,
      "tooltip": _vm.profile.country
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.profile.country)
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('mu-col', {
    staticClass: "profile-text mobile",
    attrs: {
      "width": "100",
      "desktop": "75",
      "tablet": "70",
      "align": "center"
    }
  }, [_c('mu-avatar', {
    staticClass: "relativeAvatar",
    attrs: {
      "size": 120,
      "src": _vm.profile.profile_image
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.profile.display_name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "badges"
  }, [(_vm.profile.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.progress.percentage === 100 && !_vm.isHcpView) ? _c('user-badge', {
    attrs: {
      "type": "finished-program"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profile.champion) ? _c('user-badge', {
    attrs: {
      "type": "champion"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHcpView && _vm.isHcpVerified) ? _c('user-badge', {
    attrs: {
      "type": "hcp-verified"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a264865","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/ProfileHeader/ProfileHeader.vue
// module id = 3796
// module chunks = 1